var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30147 10.9024L6.81015 3.90437C7.3021 2.9232 8.70261 2.92345 9.19419 3.90481L12.6996 10.9028C13.1438 11.7894 12.4991 12.8333 11.5075 12.8333H4.49338C3.50156 12.8333 2.85694 11.789 3.30147 10.9024Z",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.66669V8.00002",
    stroke: "#141414",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33335 10.6666C8.33335 10.8507 8.18412 11 8.00002 11C7.81593 11 7.66669 10.8507 7.66669 10.6666C7.66669 10.4826 7.81593 10.3333 8.00002 10.3333C8.18412 10.3333 8.33335 10.4826 8.33335 10.6666Z",
    stroke: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.75b3d98eb41f5a44f65aa01a0def9fdb.svg";
export { ForwardRef as ReactComponent };